import { menuPage } from '@client/routes';
import { HelpIconWithFaqDialog } from '@client/shared-components/HelpIconWithFaqDialog';
import AppBar from '@material-ui/core/AppBar';
import IconButton from '@material-ui/core/IconButton';
import useTheme from '@material-ui/core/styles/useTheme';
import withStyles from '@material-ui/core/styles/withStyles';
import Toolbar from '@material-ui/core/Toolbar';
import { UserIcon } from '@minna-technologies/minna-ui/icons/User';
import React from 'react';
import { withRouter } from 'react-router-dom';

const ProfileLogo = withRouter(({ history }) => {
  const { colors } = useTheme();

  return (
    <IconButton onClick={() => history.push(menuPage)}>
      <UserIcon nativeColor={colors.action.primary} />
    </IconButton>
  );
});

const FlexToolbar = withStyles({
  root: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
})(Toolbar);

const WhiteAppBar = withStyles((theme) => ({
  root: {
    backgroundColor: theme.colors.base.surface,
  },
}))(AppBar);

export const ProfileHeader = () => (
  <WhiteAppBar position="sticky">
    <FlexToolbar>
      <ProfileLogo />
      <HelpIconWithFaqDialog />
    </FlexToolbar>
  </WhiteAppBar>
);
